import React from "react";
import PolaroidStyleItemListView from "presentational/common/itemUnit/polaroidStyle/PolaroidStyleItemListView";
import PropTypes from "prop-types";

ItemUnitListView.propTypes = {
  itemList: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,

  markedList: PropTypes.array,
  deleteMode: PropTypes.bool,
  displayTooltip: PropTypes.bool
};

ItemUnitListView.defaultProps = {
  deleteMode: false,
  displayTooltip: false
};

function ItemUnitListView(props) {
  const { itemList, onItemClick, markedList, deleteMode, displayTooltip } =
    props;

  const handleItemClick = itemInfo => {
    onItemClick(itemInfo);
  };

  return (
    <PolaroidStyleItemListView
      itemList={itemList}
      onItemClick={handleItemClick}
      markedList={markedList}
      deleteMode={deleteMode}
      displayItemUnitTooltip={displayTooltip}
    />
  );
}

export default ItemUnitListView;
